module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Benutzerverwaltung","select":"Benutzer","logout":"Abmeldung"},"en":{"title":"User management","select":"User","logout":"Logout"},"nl":{"title":"Gebruikersbeheer","select":"Gebruiker","logout":"Afmelden"}}')
  delete Component.options._Ctor
}
